import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';

import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { BlacklistViewImpl } from './blacklistview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { BlacklistCSSStyleImpl } from './blacklistcss';
import { ManageGroupType } from '../groups/managegroup/managegrouptype';
import { BlacklistDto, BlacklistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/blacklist/blacklistdto';


export interface BlacklistComponentProps extends CRBTUIComponentProps
{
     
}

export interface BlacklistComponentState extends UIComponentState
{
    manageBlacklistType: ManageGroupType;
    blacklistDto: BlacklistDto;
}


export interface BlacklistHandler extends UIComponentHandler
{
    updateType(manageBlacklistType: ManageGroupType, blacklistDto: BlacklistDto): void;
    onCancelClicked(): void;
}

export class BlacklistComponent extends CRBTUIComponent<BlacklistComponentProps, UIComponentState> implements BlacklistHandler
{ 
    constructor(props: BlacklistComponentProps)
    {
        super(props);

        this.state = {manageBlacklistType: ManageGroupType.LIST, blacklistDto: new BlacklistDtoImpl()};
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
    }

    updateType(manageBlacklistType: ManageGroupType, blacklistDto: BlacklistDto): void {
        this.setState({manageBlacklistType: manageBlacklistType, blacklistDto: blacklistDto});
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new BlacklistViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new BlacklistCSSStyleImpl(applicationContext);
    }

    onCancelClicked(): void {
        this.setState({manageBlacklistType: ManageGroupType.LIST});
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklistcomponent.tsx